var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLaunchingAmico(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-2",
    cx: 250,
    cy: 353.97,
    rx: 231.53,
    ry: 133.67,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-2",
    d: "M34.61,337.66l240.71,139a10.34,10.34,0,0,0,9.35,0l126.57-73.08c2.59-1.49,2.59-3.91,0-5.4l-240.7-139a10.36,10.36,0,0,0-9.36,0L34.61,332.26C32,333.75,32,336.16,34.61,337.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-2",
    cx: 409.49,
    cy: 340.72,
    rx: 64.23,
    ry: 37.08,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72,314.48s1.32-17.42-2.27-34.13-12.31-29.55-23-34.57S23.2,247.6,32.43,259s28.37,31.81,28.26,61.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.54,313.87h.13a.63.63,0,0,0,.61-.65c-1-36.49-13.15-54.75-27.19-64a.63.63,0,1,0-.7,1.05C53.24,259.4,65,277.3,66,313.26A.64.64,0,0,0,66.54,313.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.68,281.7c.21,2,1.84,3.56,3.4,4.87s3.25,2.71,3.67,4.69c.86,4-3.89,7.7-2.86,11.66a6.35,6.35,0,0,0,3.34,3.73,39,39,0,0,0,3.93,1.68,18.2,18.2,0,0,0,2,.48,9.12,9.12,0,0,1,5.38,2.41c2.19,2.37,1.91,6,2.69,9.16.94,3.75,3.17,5.95,8.28,7.74L65,318.2c4.36-4.45,5.9-12.05,1.88-17.21-2.41-3.1-6.92-3.5-9.2-6.6-2-2.78-.86-6.8-2.11-10s-4.58-4.32-7.72-4.87-6.48.75-9.55-.37-5.91-2.93-9.08-3.72A10.59,10.59,0,0,0,20,277,5.65,5.65,0,0,0,17.68,281.7Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.31,297.49a.49.49,0,0,0-.14-.18c-8.23-11.66-21.12-17.2-25.47-18.18a.46.46,0,0,0-.2.9c4.13.92,16.1,6,24.16,16.73a25.25,25.25,0,0,0-20.07,1.74.48.48,0,0,0-.14.64.45.45,0,0,0,.37.2.41.41,0,0,0,.26-.07A24.28,24.28,0,0,1,49.58,298a38.13,38.13,0,0,1,6.84,23.52.47.47,0,0,0,.41.47h0a.46.46,0,0,0,.47-.44A39.08,39.08,0,0,0,50.31,297.49Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M445.42,315.37c-.17-12.13.06-23.32,6.22-40.57,5.16-14.47,18.43-29.07,27.39-28.45,8.35.58,10.2,10.83,2.69,20s-23.87,26.59-24.89,39.18l-3.19,14.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.12,312.3a.52.52,0,0,0,.41-.5c1.31-28.22,17.07-51.74,30.22-59a.55.55,0,0,0,.21-.73.53.53,0,0,0-.73-.21c-13.37,7.35-29.45,31.25-30.77,59.86a.54.54,0,0,0,.51.56A.38.38,0,0,0,449.12,312.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.72,321.53c.51-4.26,4.41-11.77,11.56-18.61,7.91-7.56,18.72-12.19,20.55-17.38,2.2-6.24-3.31-9.57-12.43-7.62-11,2.34-23.12,14.89-25.16,40.51Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.26,317.54a.54.54,0,0,0,.4-.42c4.2-22.4,19.17-32.42,26.5-34.59a.53.53,0,0,0,.36-.66.53.53,0,0,0-.67-.36c-8.1,2.39-23,12.55-27.24,35.41a.53.53,0,0,0,.43.62A.41.41,0,0,0,454.26,317.54Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--clouds--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M428.71,92.71l6.64,3.84c0-.3-.05-.59-.05-.88V93.74c0-3.42,2.4-4.81,5.37-3.1a10.61,10.61,0,0,1,3.2,3.08c.48-4.3,3.86-5.91,8-3.54,4.44,2.56,8,8.79,8,13.91V107a7.52,7.52,0,0,1-.68,3.34l5.52,3.18a6.57,6.57,0,0,1,3,5.16c0,1.9-1.33,2.67-3,1.72l-36-20.78a6.6,6.6,0,0,1-3-5.16C425.73,92.53,427.07,91.76,428.71,92.71Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.54,39.84l3.66,1.41V33.18c0-6.4,5.11-7.93,10.65-4.73h0c5.54,3.19,10,11,10,17.37V47a5.41,5.41,0,0,1,4.66.72h0a16,16,0,0,1,7.22,12.51v.53l5.1,3a10.49,10.49,0,0,1,4.76,8.23c0,3-2.13,4.26-4.76,2.75L373.54,50.82a10.49,10.49,0,0,1-4.75-8.23C368.79,39.55,370.91,38.32,373.54,39.84Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--clouds--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.37,103.93l-6.64,3.84c0-.3.06-.59.06-.88V105c0-3.43-2.41-4.82-5.37-3.1a10.35,10.35,0,0,0-3.2,3.07c-.49-4.3-3.87-5.91-8-3.54-4.44,2.56-8,8.79-8,13.92v2.87a7.52,7.52,0,0,0,.68,3.34l-5.52,3.18a6.6,6.6,0,0,0-3,5.16c0,1.9,1.34,2.67,3,1.72l36-20.78a6.57,6.57,0,0,0,3-5.16C77.35,103.76,76,103,74.37,103.93Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.06,44l-3.66,1.41V37.36c0-6.4-5.11-7.93-10.65-4.73h0c-5.54,3.19-10,11-10,17.37v1.17a5.41,5.41,0,0,0-4.66.72h0A16,16,0,0,0,67.84,64.4v.53l-5.1,2.95A10.49,10.49,0,0,0,58,76.11c0,3,2.13,4.26,4.76,2.75L104.06,55a10.52,10.52,0,0,0,4.75-8.23C108.81,43.73,106.68,42.5,104.06,44Z",
    style: {
      fill: "#f0f0f0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Stars--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--stars--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.26,82.33a1.08,1.08,0,1,1-1.53,0A1.09,1.09,0,0,1,111.26,82.33Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.24,87.05a1.76,1.76,0,1,1-2.45,2.54,1.76,1.76,0,0,1,2.45-2.54Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444,34.84a1.08,1.08,0,1,1-.6,1.41A1.09,1.09,0,0,1,444,34.84Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.35,27.66a1.76,1.76,0,1,1,1.32,3.27,1.76,1.76,0,0,1-1.32-3.27Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.93,150.76a1.77,1.77,0,1,1-1.76-1.76A1.76,1.76,0,0,1,388.93,150.76Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.66,155.58a1.06,1.06,0,1,1-1.05-1.05A1,1,0,0,1,383.66,155.58Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.68,149a.85.85,0,1,1-.85-.85A.85.85,0,0,1,380.68,149Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.86,104.26a1.33,1.33,0,1,1-1.82.49A1.33,1.33,0,0,1,277.86,104.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.16,99.87a.78.78,0,1,1-1.06.29A.78.78,0,0,1,281.16,99.87Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293,186.87a1.32,1.32,0,1,1-1.81.48A1.33,1.33,0,0,1,293,186.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373,89.87a1.32,1.32,0,1,1-1.81.48A1.33,1.33,0,0,1,373,89.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.32,182.48a.77.77,0,0,1,.28,1.06.78.78,0,1,1-1.34-.78A.77.77,0,0,1,296.32,182.48Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.24,143.27l-2.5.87L469,146.7a.3.3,0,0,1-.53.1l-1.6-2.12-2.64.12a.3.3,0,0,1-.27-.47l1.52-2.17-.93-2.49a.3.3,0,0,1,.37-.39l2.54.77,2.07-1.65a.3.3,0,0,1,.49.23l.05,2.65,2.21,1.46A.3.3,0,0,1,472.24,143.27Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.61,135.61l-2.51.86-.7,2.56a.31.31,0,0,1-.54.1L319.27,137l-2.65.11a.29.29,0,0,1-.26-.47l1.51-2.17-.93-2.48a.3.3,0,0,1,.37-.4l2.54.77,2.07-1.65a.3.3,0,0,1,.49.23l0,2.65,2.21,1.46A.31.31,0,0,1,324.61,135.61Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.19,227.63l-1.46.51-.42,1.5a.18.18,0,0,1-.31.06l-.94-1.24-1.55.07a.18.18,0,0,1-.16-.28l.89-1.27-.54-1.46a.17.17,0,0,1,.21-.23l1.49.45,1.22-1a.18.18,0,0,1,.29.14l0,1.55,1.29.86A.17.17,0,0,1,454.19,227.63Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.93,152.88l-4,1.4-1.14,4.11a.48.48,0,0,1-.85.17l-2.58-3.41-4.26.19a.48.48,0,0,1-.42-.76l2.44-3.5-1.5-4a.48.48,0,0,1,.6-.63l4.08,1.24,3.34-2.66a.49.49,0,0,1,.79.37l.08,4.26L112,152A.48.48,0,0,1,111.93,152.88Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Star--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M319,75.44a9.9,9.9,0,1,1,9.9-9.9A9.91,9.91,0,0,1,319,75.44Zm0-19.28a9.39,9.39,0,1,0,9.39,9.38A9.39,9.39,0,0,0,319,56.16Z",
    style: {
      fill: "#BA68C8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M321.87,65.55A2.83,2.83,0,1,1,319,62.72,2.82,2.82,0,0,1,321.87,65.55Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--star--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.55,216.49a9.9,9.9,0,1,1,9.89-9.9A9.91,9.91,0,0,1,64.55,216.49Zm0-19.29a9.39,9.39,0,1,0,9.38,9.39A9.4,9.4,0,0,0,64.55,197.2Z",
    style: {
      fill: "#BA68C8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M67.38,206.59a2.83,2.83,0,1,1-2.83-2.83A2.83,2.83,0,0,1,67.38,206.59Z",
    style: {
      fill: "#f0f0f0"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mobile--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--mobile--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M398.12,401l-111.9,64.6a12.06,12.06,0,0,1-11.68.22L49.25,335.76c-3.55-2.05-6.43-6.63-6.43-10.24s2.88-8.19,6.43-10.23l111.49-64.37a14.26,14.26,0,0,1,12.85,0L398.12,380.55c3.55,2.05,6.43,6.63,6.43,10.24S401.67,399,398.12,401Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.74,250.92,49.25,315.29c-3.55,2-6.43,6.63-6.43,10.23s2.88,8.19,6.43,10.24L274.54,465.84a12.44,12.44,0,0,0,5.59,1.38V312.43L173.59,250.92A14.26,14.26,0,0,0,160.74,250.92Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.22,465.62,398.12,401c3.55-2,6.43-6.63,6.43-10.23s-2.88-8.19-6.43-10.24l-118-68.12V467.22A11.92,11.92,0,0,0,286.22,465.62Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.56,454.11a12.58,12.58,0,0,1-11.34,0l-223-128.75c-4.8-2.77-4.8-7.3,0-10.06l111.51-64.38a14.26,14.26,0,0,1,12.85,0L398.11,380.55c3.54,2,3.54,5.38,0,7.42Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.56,454.11a12.58,12.58,0,0,1-11.34,0l-223-128.75c-4.8-2.77-4.8-7.3,0-10.06l111.51-64.38a14.26,14.26,0,0,1,12.85,0L398.11,380.55c3.54,2,3.54,5.38,0,7.42Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.73,441.15a13.56,13.56,0,0,1-12.22,0L68.62,330.36c-3.37-1.95-3.37-5.1,0-7.05l104.9-60.56a13.56,13.56,0,0,1,12.22,0L377.62,373.54c3.36,1.94,3.36,5.11,0,7Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.26,261.32a12.37,12.37,0,0,0-5.74,1.43L68.62,323.31c-3.37,1.95-3.37,5.1,0,7.05l20.8,12L179.26,285Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.81,267.34a13.56,13.56,0,0,0-12.22,0L68.7,327.89a6.29,6.29,0,0,0-1.6,1.28,6.53,6.53,0,0,0,1.52,1.19L260.51,441.15a13.56,13.56,0,0,0,12.22,0l104.89-60.56a6.36,6.36,0,0,0,1.59-1.26,6.31,6.31,0,0,0-1.51-1.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107,295l18.59-10.73c1.11-.64,1.16-1.64.12-2.25a4.31,4.31,0,0,0-3.89.08L103.2,292.81c-1.11.64-1.17,1.65-.13,2.25A4.3,4.3,0,0,0,107,295Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.89,276.58a1.14,1.14,0,0,0,0-2.17,4.17,4.17,0,0,0-3.77,0,1.14,1.14,0,0,0,0,2.17A4.17,4.17,0,0,0,138.89,276.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.43,272.22a1.14,1.14,0,0,0,0-2.17,4.17,4.17,0,0,0-3.77,0,1.14,1.14,0,0,0,0,2.17A4.11,4.11,0,0,0,146.43,272.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.14,307a1.14,1.14,0,0,0,0-2.17,4.17,4.17,0,0,0-3.77,0,1.14,1.14,0,0,0,0,2.17A4.11,4.11,0,0,0,86.14,307Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.67,302.68a1.15,1.15,0,0,0,0-2.18,4.17,4.17,0,0,0-3.77,0,1.15,1.15,0,0,0,0,2.18A4.17,4.17,0,0,0,93.67,302.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.92,369.19a4.3,4.3,0,0,1,2,3.33,1.25,1.25,0,0,1-.56,1.18c-.24.13-1.15.68-1.4.82a1.48,1.48,0,0,1-1.45-.17L92.39,359.27a4.33,4.33,0,0,1-2-3.34,1.29,1.29,0,0,1,.51-1.14c.25-.16,1.2-.71,1.45-.85a1.5,1.5,0,0,1,1.45.16Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.92,369.19a4.3,4.3,0,0,1,2,3.33,1.25,1.25,0,0,1-.56,1.18c-.24.13-1.15.68-1.4.82a1.48,1.48,0,0,1-1.45-.17L92.39,359.27a4.33,4.33,0,0,1-2-3.34,1.29,1.29,0,0,1,.51-1.14c.25-.16,1.2-.71,1.45-.85a1.5,1.5,0,0,1,1.45.16Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.52,370,92.39,354.91c-1.11-.64-2-.18-2,1a4.33,4.33,0,0,0,2,3.34l26.13,15.08c1.11.64,2,.19,2-1A4.3,4.3,0,0,0,118.52,370Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.52,370,92.39,354.91c-1.11-.64-2-.18-2,1a4.33,4.33,0,0,0,2,3.34l26.13,15.08c1.11.64,2,.19,2-1A4.3,4.3,0,0,0,118.52,370Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,349a4.3,4.3,0,0,1,2,3.33,1.26,1.26,0,0,1-.56,1.17l-1.4.82a1.45,1.45,0,0,1-1.45-.16l-12.32-7.11a4.32,4.32,0,0,1-2-3.34,1.26,1.26,0,0,1,.51-1.14c.25-.16,1.2-.71,1.45-.85a1.49,1.49,0,0,1,1.45.17Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,349a4.3,4.3,0,0,1,2,3.33,1.26,1.26,0,0,1-.56,1.17l-1.4.82a1.45,1.45,0,0,1-1.45-.16l-12.32-7.11a4.32,4.32,0,0,1-2-3.34,1.26,1.26,0,0,1,.51-1.14c.25-.16,1.2-.71,1.45-.85a1.49,1.49,0,0,1,1.45.17Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.55,349.81,71.23,342.7c-1.11-.64-2-.19-2,1a4.32,4.32,0,0,0,2,3.34l12.32,7.11c1.11.64,2,.18,2-1A4.29,4.29,0,0,0,83.55,349.81Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.55,349.81,71.23,342.7c-1.11-.64-2-.19-2,1a4.32,4.32,0,0,0,2,3.34l12.32,7.11c1.11.64,2,.18,2-1A4.29,4.29,0,0,0,83.55,349.81Z",
    style: {
      opacity: 0.30000000000000004
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Button--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-2",
    d: "M271.55,434.83a11.79,11.79,0,0,1-5.83-1.44l-23.84-13.76a5.6,5.6,0,0,1,0-10.2l76.65-44.25a12.6,12.6,0,0,1,11.66,0L354,379a5.58,5.58,0,0,1,0,10.19l-76.64,44.25A11.82,11.82,0,0,1,271.55,434.83Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--button--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M354.32,373.94a3,3,0,0,0-1.8-2.5l-23.83-13.76a9.57,9.57,0,0,0-8.66,0l-76.65,44.25a3,3,0,0,0-1.79,2.5V414.5a3,3,0,0,0,1.79,2.5l23.84,13.76a9.57,9.57,0,0,0,8.66,0l76.64-44.25a3,3,0,0,0,1.8-2.5Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.52,371.44l-23.83-13.76a9.57,9.57,0,0,0-8.66,0l-48.48,28V431.8a8.86,8.86,0,0,0,4.33-1l76.64-44.25a3,3,0,0,0,1.8-2.5V373.94A3,3,0,0,0,352.52,371.44Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.38,401.93a3,3,0,0,0-1.79,2.5V414.5a3,3,0,0,0,1.79,2.5l23.84,13.76a8.86,8.86,0,0,0,4.33,1V385.67Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.22,420.69l-23.84-13.76c-2.39-1.38-2.39-3.62,0-5L320,357.68a9.57,9.57,0,0,1,8.66,0l23.83,13.76c2.39,1.38,2.39,3.62,0,5l-76.64,44.25A9.57,9.57,0,0,1,267.22,420.69Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M267.22,420.69l-23.84-13.76c-2.39-1.38-2.39-3.62,0-5L320,357.68a9.57,9.57,0,0,1,8.66,0l23.83,13.76c2.39,1.38,2.39,3.62,0,5l-76.64,44.25A9.57,9.57,0,0,1,267.22,420.69Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.87, -0.5, 0.87, 0.5, 271.51, 411.8)",
    style: {
      fontSize: "24.411169052124023px",
      fill: "#fff",
      fontFamily: "Rubik-Bold, Rubik",
      fontWeight: 700,
      letterSpacing: "-0.006990758519889648em"
    }
  }, "S", /*#__PURE__*/React.createElement("tspan", {
    x: 16.28,
    y: 0,
    style: {
      letterSpacing: "-0.06999259442267197em"
    }
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 29.98,
    y: 0,
    style: {
      letterSpacing: "-0.000005000542575028361em"
    }
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    x: 47.5,
    y: 0,
    style: {
      letterSpacing: "-0.005995650547459006em"
    }
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    x: 64.32,
    y: 0,
    style: {
      letterSpacing: "-0.023982602189836024em"
    }
  }, "T"))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Leg--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M403.05,311.14c4.16-1.78,11.18-4.62,11.34-4.65a4.84,4.84,0,0,1,5.19,2.78c.91,1.78,6,2.86,6,9.33,0,1.76-5.06,3.17-6.44,1.76-1.67,1.7-10.64,8.82-10.64,8.82Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.77,336.42c.12.88-.15,1.46,1.09,2.41s6.05,2.35,10.08,1.66,9.07-2.71,9.74-8.3-.1-7.92-1.31-10.35-4.34-5.72-5.28-7.65-1-5.19-1.32-7-1-4.46-3.54-5.77a7.51,7.51,0,0,0-4.61-.87l-2.45,1.21s6.21,18.19,8,22.75S418.77,336.42,418.77,336.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.89,324.79c-1.3-5.56-6.11-7.88-7-10.65s.1-7.77-3-10.51a8,8,0,0,0-6.76-1.88s-5.34,1.57-7.49,3.13a10.61,10.61,0,0,0-3,3l1.18-.47c2.13-.45,5.72,1.21,6.76,2.89a21.64,21.64,0,0,1,1.41,2.41,11.08,11.08,0,0,0,1.4,2.63c.36.45,1.32,1.11,1.29,1.74s-1,.06-1.31-.12c-.75-.37-2.16-.9-2.64.15a3.31,3.31,0,0,0-.19,1.45,4.8,4.8,0,0,1-.17,1.85,3.31,3.31,0,0,1-1.08,1.53l-.68.58s.74.56,2,1.65a20.71,20.71,0,0,1,3.59,4.78s-2,1.66-3.29,2.89-.86,4.1.06,4.8,3.25,2.69,8.56,2.53c7.95-.22,9.94-4.24,10.63-6.57S438.72,328.32,437.89,324.79Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.89,324.79c-1.3-5.56-6.11-7.88-7-10.65s.1-7.77-3-10.51a8,8,0,0,0-6.76-1.88s-5.34,1.57-7.49,3.13a10.61,10.61,0,0,0-3,3l1.18-.47c2.13-.45,5.72,1.21,6.76,2.89a21.64,21.64,0,0,1,1.41,2.41,11.08,11.08,0,0,0,1.4,2.63c.36.45,1.32,1.11,1.29,1.74s-1,.06-1.31-.12c-.75-.37-2.16-.9-2.64.15a3.31,3.31,0,0,0-.19,1.45,4.8,4.8,0,0,1-.17,1.85,3.31,3.31,0,0,1-1.08,1.53l-.68.58s.74.56,2,1.65a20.71,20.71,0,0,1,3.59,4.78s-2,1.66-3.29,2.89-.86,4.1.06,4.8,3.25,2.69,8.56,2.53c7.95-.22,9.94-4.24,10.63-6.57S438.72,328.32,437.89,324.79Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.69,328c1.16-1.4,6-2.52,8.58-1.76.43-.59.57-.89-.11-1.38a10.22,10.22,0,0,0-6.28.12,7.59,7.59,0,0,0-3.06,1.73A1.56,1.56,0,0,0,421.69,328Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420,325.67c1-1.53,5.64-3.24,8.29-2.8.36-.63.46-1-.28-1.35a10.19,10.19,0,0,0-6.21.88,7.77,7.77,0,0,0-2.82,2.09S419.16,325.49,420,325.67Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.88,276.61l25.45-6.41c1.24,5.13,2,15.26-.12,23s-9.32,20.66-9.32,20.66l9.93-4s3.31-.12,6.34,4.55,0,11.71,0,11.71a230.07,230.07,0,0,1-26.33,19.1c-13.15,7.91-21.46,10.37-28.64,4.64-4.24-3.38-4.27-10.44-2.71-19.45,1.76-10.12,25.36-53.82,25.36-53.82",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.48,310a3.93,3.93,0,0,0-.66-.08l-9.93,4s5.81-10.45,8.53-18.19l-22.11-7.15c1.38,7.93,7.84,15.37,7.84,15.37s-9.35,23-13.23,34.55-10.72,11.25-17,9.34-6.26-10.41-6.26-10.51c-.37,5.71.48,10.15,3.57,12.61,7.18,5.73,15.49,3.27,28.64-4.64a217.09,217.09,0,0,0,22.53-16Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.07,324.76a61.94,61.94,0,0,1,14.79-13c-2.28-2-4-1.85-4-1.85l-9.93,4s-8.53,18.47-15.48,21.28A32.91,32.91,0,0,0,395.07,324.76Z",
    style: {
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Le--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M427.61,324.13c4.16-1.77,11.18-4.62,11.34-4.65a4.86,4.86,0,0,1,5.19,2.78c.91,1.79,6,2.86,6,9.33,0,1.76-5.05,3.17-6.43,1.77-1.67,1.7-10.65,8.81-10.65,8.81Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.33,349.41c.12.88-.31,1.28.93,2.24s6,2.53,10.05,1.85,9.08-3.15,9.74-7.83c.79-5.58.09-8.4-1.12-10.84s-4.34-5.71-5.28-7.65-1-5.18-1.32-7-1-4.46-3.54-5.77a7.42,7.42,0,0,0-4.61-.87l-2.46,1.21s6.22,18.19,8,22.75S443.33,349.41,443.33,349.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.45,337.78c-1.3-5.56-6.11-7.88-7-10.65s.1-7.76-3-10.51a8,8,0,0,0-6.77-1.87s-5.33,1.56-7.48,3.12a10.71,10.71,0,0,0-3,3l1.18-.48c2.13-.44,5.72,1.21,6.76,2.9a20,20,0,0,1,1.41,2.41,10.83,10.83,0,0,0,1.4,2.62c.36.45,1.32,1.12,1.29,1.74s-1,.06-1.32-.11c-.74-.38-2.15-.91-2.63.15a3.28,3.28,0,0,0-.19,1.44,5,5,0,0,1-.17,1.86,3.36,3.36,0,0,1-1.08,1.53l-.68.57s.74.56,2,1.65A20.71,20.71,0,0,1,446.8,342s-2,1.67-3.29,2.9-.86,4.09.06,4.8,3.25,2.68,8.56,2.53c7.95-.23,10.09-4.42,10.57-6.69A15.12,15.12,0,0,0,462.45,337.78Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.45,337.78c-1.3-5.56-6.11-7.88-7-10.65s.1-7.76-3-10.51a8,8,0,0,0-6.77-1.87s-5.33,1.56-7.48,3.12a10.71,10.71,0,0,0-3,3l1.18-.48c2.13-.44,5.72,1.21,6.76,2.9a20,20,0,0,1,1.41,2.41,10.83,10.83,0,0,0,1.4,2.62c.36.45,1.32,1.12,1.29,1.74s-1,.06-1.32-.11c-.74-.38-2.15-.91-2.63.15a3.28,3.28,0,0,0-.19,1.44,5,5,0,0,1-.17,1.86,3.36,3.36,0,0,1-1.08,1.53l-.68.57s.74.56,2,1.65A20.71,20.71,0,0,1,446.8,342s-2,1.67-3.29,2.9-.86,4.09.06,4.8,3.25,2.68,8.56,2.53c7.95-.23,10.09-4.42,10.57-6.69A15.12,15.12,0,0,0,462.45,337.78Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.25,341c1.16-1.41,6-2.53,8.58-1.77.43-.58.56-.89-.11-1.37a10.26,10.26,0,0,0-6.28.11,7.73,7.73,0,0,0-3.06,1.73A1.57,1.57,0,0,0,446.25,341Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.54,338.67c1-1.54,5.65-3.24,8.3-2.81.36-.63.45-.95-.28-1.35a10.28,10.28,0,0,0-6.21.88,7.83,7.83,0,0,0-2.83,2.1S443.72,338.49,444.54,338.67Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.43,327.07c-3-4.68-6.34-4.55-6.34-4.55l-9.93,4s7.72-12.63,10.64-20.11c3.47-8.85,4.74-14.1,3.2-26.9l-35.81-.63-19.31-2.25A34.19,34.19,0,0,0,393.3,303.1s-11.75,29.85-13.51,40c-1.56,9-1.53,16.07,2.71,19.45,7.18,5.73,15.49,3.27,28.64-4.64a230.07,230.07,0,0,0,26.33-19.1S440.47,331.75,437.43,327.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.34,337.39a61.7,61.7,0,0,1,14.77-13c-2.52-2.13-4-1.88-4-1.88l-9.93,4s-8.53,18.47-15.48,21.28A32.88,32.88,0,0,0,420.34,337.39Z",
    style: {
      fill: "#37474f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M367.32,287.68c5.22-6.75,4.7-6,6-14.37s6-43.08,6-43.08L373.57,215s-10,3.05-12.39,12.16c-3.48,13.15-6.9,46.82-6.9,46.82l-2.9,6.1Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.12,214.18s-6.26,1.23-10.48,5.11c-3.13,2.87-4.47,9-5.69,14.61-1.44,6.62-3.11,20.7-3.11,20.7s9.57,9.27,21.32,7.76l6.35-27.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.14,228.44a194.7,194.7,0,0,1,11.13,55.75c-6.81,7.91-46.39,15.74-59.25-.32,2.83-19-5.25-25.34-8-48.05-1.22-10-4.07-19.27,13.43-23.87s30.14-1.33,30.14-1.33C417.83,214,422,222.72,424.14,228.44Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.54,201.82c1.23-2.52-.64-7.82-4.45-12.74s-9.66-7.62-12.24-3.89,2.31,12.84,5.93,15.28S436.74,205.49,438.54,201.82Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.38,108.08c-2.72.39-1.09,6.06,0,10.58,1,4.17,1.81,7.49,1.18,8.18-.9,1-2.91-3.49-5.41-4.34-1.26-.43-2.76-.12-2.93.84s.62,1.25,2,3.34c1.06,1.58,3.12,8.24,6.15,11.17,1.18,1.15,2,4.94,2.11,7.87.58,13-.53,28.35-.53,28.35s-4.39,7.82-11.31,20.89c-3.18,6-8.53,15-8.53,15-1,6.26,3.58,20.74,16.66,20.16-1.63-5.51,11.12-27.44,17.41-39.11,4.4-8.17,4.92-9.23,4.79-12.86-.37-10.53-1.27-12.11-2.22-20.8-1.09-9.88-1.47-14.88-1.56-15.95-.36-4.26.84-6.19,1.21-8.62.54-3.6.72-6.17-.23-9.09a3,3,0,0,0-1.52-2c-.42-.16-.88-.17-1.29-.33a16.76,16.76,0,0,0-2-1c-.93-.21-2.05.62-3,.36-.4-.12-1.37-1-1.79-1a7,7,0,0,0-1.89.61c-.38.11-1.3.74-1.59.28a57.13,57.13,0,0,1-2.18-6.17C427.89,111.25,426.93,107.86,425.38,108.08Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.89,125.77c1,2.61,1.3,5.7,2.83,6.2a2.55,2.55,0,0,1,4.59-.75,2,2,0,0,0,1.75-1.15,2.08,2.08,0,0,0,3-.28c-.15.87-1.05,2.39-2.54,1.49,0,0-1.7,1.79-3.32.53,0,0,1.9,1.33,1.64,4.85a7.7,7.7,0,0,0-2.72-4.32,3.17,3.17,0,0,1-3.23.28C431.27,131.71,430.89,125.77,430.89,125.77Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.91,209.67a38.74,38.74,0,0,0,5.94-5.93c2.76-3.28,11-18.55,11-18.55s.33,5.62,5.62,11.28c6.75,7.22,11.07,5.35,11.07,5.35s-5.22,9.7-7.93,15.74c-2.34,5.23-5.56,11.87-4.79,15.67-1.4,2.07-7.68.72-14.53-5.55C403.89,220.9,404.91,209.67,404.91,209.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.82,194.07a13.79,13.79,0,0,0,5.95,1.3c1.76-.13,3.5.43,5.29.44,3.84,0,5.54,8.61,8.52,6.15.38-4.2,7.13-13.8,5.9-24.59-.62-5.47-3.58-10.64-9.09-10.89.27,0-1.34-2.73-1.57-2.95a9.44,9.44,0,0,0-3.54-2,20.06,20.06,0,0,0-8.64-.76,35.29,35.29,0,0,0-8.45,1.75c-2.89,1-5.65,2.15-8.74,1.27-2.6-.73-1,4.33.2,5.1-1.06.28-1.86-1.46-2.74-1.5s-1,1.47-1,2.08c.28,2.75.63,4.5,2.58,6.4-1.89,1.76-.43,3.9,1.25,5.13,2,1.48,3.15,3.87,4.76,5.81A24.55,24.55,0,0,0,376.82,194.07Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.61,174c-1.42,3.14,0,12.9,1.77,21.66a11.78,11.78,0,0,0,1.68.14c3.84,0,5.54,8.61,8.52,6.15.38-4.2,7.13-13.8,5.9-24.59-.62-5.47-3.58-10.64-9.09-10.89A14,14,0,0,0,384.61,174Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.61,174a9.73,9.73,0,0,0,7.84,5.62,23.89,23.89,0,0,0,.73,8.14,4.42,4.42,0,0,0,.79,1.56,2,2,0,0,0,1.54.74c.79,0,1.06-.54,1.23-1.18a19.77,19.77,0,0,1,.93-2.42,4.7,4.7,0,0,1,.6-1c1.07-1.24,4.45-3,6.51.59s-.4,9.21-3.16,10.33c-4.75,1.92-6.19-1.3-6.19-1.3l2.62,15.62c-5.05,7.63-18.62,8.46-16.23,4.2l-1.66-6.74a23.17,23.17,0,0,1-5.92.88c-3.62-.27-7-4-8.41-7.79-3-7.75-3.9-19.42-2.13-25.11C370.77,181,377.48,175.7,384.61,174Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.66,186.54a1.65,1.65,0,1,1-1.88-1.38A1.65,1.65,0,0,1,382.66,186.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.62,188.77a1.65,1.65,0,1,1-1.88-1.38A1.64,1.64,0,0,1,369.62,188.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.16,208.21s6.86-2.46,9.53-4.17a14.57,14.57,0,0,0,4.38-5.44,16.73,16.73,0,0,1-2.05,5.45c-1.83,2.78-11.38,6.1-11.38,6.1Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "374.85 184.54 376.43 195.18 370.9 195.25 374.85 184.54",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.07,182l4,1.26a2.19,2.19,0,0,0-1.4-2.68A2,2,0,0,0,380.07,182Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.78,186.09l3.21-2.7a2,2,0,0,0-2.91-.31A2.2,2.2,0,0,0,364.78,186.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.64,196l-5.28,3.18a3,3,0,0,0,4.15,1.13A3.24,3.24,0,0,0,381.64,196Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.43,197.44a2,2,0,0,1,.59-.11,3.22,3.22,0,0,1-1.51,3,1.63,1.63,0,0,0-.19.09,1.4,1.4,0,0,1-.1-.16A2.17,2.17,0,0,1,381.43,197.44Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.28,274c-1.48,2.51-8.8,16.13-11.59,20.8-2.05,3.4-8.29,14.78-9.36,17.15-2.17,4.82-5.41,10.36-4.86,15.86.13,1.34.5,2.56.5,3.91,0,1.55-.19,3.09.78,4.38.29.38.79.66,1,1.09s.28,1.36.63,1.93c1,1.58,2.16,0,2.77-.93,2.48-3.87,3.93-8.28,6.41-12.13a39.7,39.7,0,0,1,3.34-4.78c.23-.26.92-.74,1.29-.56s.22,1,.22,1.37c0,1-.05,1.94,0,2.91a4.75,4.75,0,0,0,1.54,3.5,1.7,1.7,0,0,0,2,.21,1.64,1.64,0,0,0,.56-1.13c.05-.43,0-.87,0-1.3,0-1.79,1-3.41,1.5-5.13a17.14,17.14,0,0,0,.45-5.35,31,31,0,0,1,.09-5.37,10.62,10.62,0,0,1,2-5.22c1.18-1.5,4.19-5.52,6.65-8.55,4.39-5.4,7.77-9.29,10.8-14Z",
    style: {
      fill: "#ffa8a7"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Rocket--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--rocket--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-2",
    d: "M320.6,337.87a13.41,13.41,0,0,0-5.06-1.57c-.06-2.14-1.5-4.27-4.33-5.9-5.79-3.34-15.17-3.34-21,0-5,2.88-5.67,7.3-2.06,10.6-6.31-.64-13,.44-17.91,3.25-3,1.73-4.84,3.85-5.58,6.08-9-2.62-20.29-1.77-27.82,2.57a18.51,18.51,0,0,0-3.67,2.76h0c-8.24-4.75-21.6-4.75-29.84,0-3.09,1.79-5,4-5.8,6.3A12.58,12.58,0,0,0,192,356.3c-7.06-4.08-17.89-4.65-26-1.73a15.47,15.47,0,0,0-5.66-5.22c-7.43-4.29-18.51-5.17-27.47-2.67,1.72-3.75,0-7.91-5-10.85-5.24-3-12.72-4-19.36-2.83,2.72-3.15,1.81-7.07-2.73-9.69-5.69-3.29-14.91-3.29-20.6,0A9,9,0,0,0,81.43,327a14.66,14.66,0,0,0-9,1.44c-3.72,2.15-3.72,5.64,0,7.79a14.93,14.93,0,0,0,13.5,0,5.19,5.19,0,0,0,.52-.34,22.87,22.87,0,0,0,11.39,1.69c-5.07,4.38-4.27,10.35,2.43,14.22,5.56,3.21,13.65,4.06,20.57,2.58-3.15,4.93-1.33,10.68,5.53,14.63,8.66,5,22.27,5.38,31.7,1.15a14.58,14.58,0,0,0,4.14,3.41c7.71,4.45,19.89,4.74,28.18.87.18.12.37.25.57.36a15.57,15.57,0,0,0,14.13,0,7.85,7.85,0,0,0,.9-.61c8.25,3.43,19.8,3,27.22-1.27a17.09,17.09,0,0,0,2.05-1.4c.51.36,1.06.71,1.64,1,9.39,5.42,24.61,5.42,34,0,4.32-2.49,6.62-5.69,7-8.95,7.16,1.47,15.44.56,21.16-2.75,7.52-4.34,7.9-11.23,1.16-15.84a24.16,24.16,0,0,0,4.59-.31,7.22,7.22,0,0,0,1.73,1.35,15.61,15.61,0,0,0,14.12,0C324.5,343.78,324.5,340.12,320.6,337.87Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Smoke--inject-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 196.5,
    cy: 338.87,
    rx: 58.18,
    ry: 23.85,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 196.5,
    cy: 338.87,
    rx: 58.18,
    ry: 23.85,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 196.5,
    cy: 338.87,
    rx: 58.18,
    ry: 23.85,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M135.37,322.93a25.85,25.85,0,0,1,51.69,0c0,.25,0,.47,0,.72s0,.47,0,.72c-.3,3.58-2.82,7.09-7.57,9.84-10.08,5.83-26.47,5.83-36.58,0-4.72-2.75-7.24-6.26-7.54-9.84,0-.25,0-.47,0-.72S135.35,323.18,135.37,322.93Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.37,322.93a25.85,25.85,0,0,1,51.69,0c0,.25,0,.47,0,.72s0,.47,0,.72c-.3,3.58-2.82,7.09-7.57,9.84-10.08,5.83-26.47,5.83-36.58,0-4.72-2.75-7.24-6.26-7.54-9.84,0-.25,0-.47,0-.72S135.35,323.18,135.37,322.93Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150,300.37h0a25.82,25.82,0,0,1,37.06,22.56c0,.25,0,.47,0,.72s0,.47,0,.72c-.3,3.58-2.82,7.09-7.57,9.84a34.47,34.47,0,0,1-13,4.05c6.71-1.16,11-8.65,9-16.92C173.12,311.75,163.42,297.89,150,300.37Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M135.37,324.37c0-.25,0-.47,0-.72s0-.47,0-.72a25.73,25.73,0,0,1,8.78-18.68c-2.81,2.89-9.06,13.77-2.27,22.07,4.47,5.45,25.66,13.24,43.1,3.23a18,18,0,0,1-5.49,4.66c-10.08,5.83-26.47,5.83-36.58,0C138.19,331.46,135.67,328,135.37,324.37Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.48,303.61c-1.16,2.64,1.06,6.16,5,7.88s8,1,9.16-1.67-1.07-6.16-5-7.88S162.64,301,161.48,303.61Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.45,314.34c-.6,1.37.28,3.08,2,3.82s3.53.23,4.13-1.14-.27-3.09-1.95-3.83A3.08,3.08,0,0,0,176.45,314.34Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M245.18,323.62a22,22,0,0,0-43.89,0c0,.21,0,.4,0,.61s0,.4,0,.61c.25,3,2.39,6,6.43,8.36,8.56,4.95,22.48,4.95,31.06,0,4-2.33,6.16-5.32,6.4-8.36,0-.21,0-.4,0-.61S245.2,323.83,245.18,323.62Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M245.18,323.62a22,22,0,0,0-43.89,0c0,.21,0,.4,0,.61s0,.4,0,.61c.25,3,2.39,6,6.43,8.36,8.56,4.95,22.48,4.95,31.06,0,4-2.33,6.16-5.32,6.4-8.36,0-.21,0-.4,0-.61S245.2,323.83,245.18,323.62Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.76,304.46h0a21.93,21.93,0,0,0-31.47,19.16c0,.21,0,.4,0,.61s0,.4,0,.61c.25,3,2.39,6,6.43,8.36a29.22,29.22,0,0,0,11,3.44c-5.69-1-9.38-7.35-7.63-14.37C213.13,314.13,221.37,302.35,232.76,304.46Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M245.18,324.84c0-.21,0-.4,0-.61s0-.4,0-.61a21.81,21.81,0,0,0-7.45-15.86c2.39,2.45,7.69,11.69,1.93,18.74-3.79,4.63-21.79,11.24-36.6,2.75a15.29,15.29,0,0,0,4.66,3.95c8.56,4.95,22.48,4.95,31.06,0C242.79,330.87,244.94,327.88,245.18,324.84Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223,307.22c1,2.23-.91,5.23-4.22,6.68s-6.8.82-7.78-1.42.91-5.23,4.22-6.68S222,305,223,307.22Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.3,316.33a2.89,2.89,0,1,1-3.52-1A2.6,2.6,0,0,1,210.3,316.33Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M267.23,327.59a14.52,14.52,0,0,0-29,0c0,.14,0,.26,0,.4s0,.27,0,.41c.17,2,1.58,4,4.25,5.52,5.67,3.27,14.87,3.27,20.54,0,2.66-1.54,4.08-3.51,4.24-5.52,0-.14,0-.27,0-.41S267.24,327.73,267.23,327.59Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M267.23,327.59a14.52,14.52,0,0,0-29,0c0,.14,0,.26,0,.4s0,.27,0,.41c.17,2,1.58,4,4.25,5.52,5.67,3.27,14.87,3.27,20.54,0,2.66-1.54,4.08-3.51,4.24-5.52,0-.14,0-.27,0-.41S267.24,327.73,267.23,327.59Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259,314.92h0a14.5,14.5,0,0,0-20.82,12.67c0,.14,0,.26,0,.4s0,.27,0,.41c.17,2,1.58,4,4.25,5.52a19.25,19.25,0,0,0,7.29,2.27c-3.77-.65-6.21-4.85-5.05-9.5C246,321.31,251.48,313.52,259,314.92Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M267.23,328.4c0-.14,0-.27,0-.41s0-.26,0-.4a14.42,14.42,0,0,0-4.93-10.49c1.58,1.62,5.09,7.73,1.27,12.39-2.5,3.06-14.4,7.44-24.2,1.82a10.31,10.31,0,0,0,3.08,2.61c5.67,3.27,14.87,3.27,20.54,0C265.65,332.38,267.07,330.41,267.23,328.4Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.57,316.74c.65,1.48-.6,3.46-2.79,4.42s-4.49.54-5.14-.94.6-3.46,2.79-4.42S251.92,315.26,252.57,316.74Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M244.16,322.76a1.91,1.91,0,1,1-2.32-.64A1.72,1.72,0,0,1,244.16,322.76Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M292.18,333.85a19.73,19.73,0,0,0-39.45,0c0,.19,0,.36,0,.55s0,.36,0,.55c.23,2.73,2.15,5.41,5.78,7.5,7.69,4.45,20.2,4.45,27.91,0,3.61-2.09,5.54-4.77,5.76-7.5a7.57,7.57,0,0,0,0-1.1Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.18,333.85a19.73,19.73,0,0,0-39.45,0c0,.19,0,.36,0,.55s0,.36,0,.55c.23,2.73,2.15,5.41,5.78,7.5,7.69,4.45,20.2,4.45,27.91,0,3.61-2.09,5.54-4.77,5.76-7.5a7.57,7.57,0,0,0,0-1.1Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281,316.63h0a19.71,19.71,0,0,0-28.29,17.22c0,.19,0,.36,0,.55s0,.36,0,.55c.23,2.73,2.15,5.41,5.78,7.5a26.21,26.21,0,0,0,9.9,3.09c-5.12-.88-8.44-6.6-6.86-12.91C263.37,325.32,270.77,314.74,281,316.63Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M292.18,335a7.57,7.57,0,0,0,0-1.1,19.64,19.64,0,0,0-6.7-14.26c2.14,2.2,6.91,10.51,1.73,16.84-3.41,4.17-19.58,10.11-32.89,2.47a13.56,13.56,0,0,0,4.19,3.55c7.69,4.45,20.2,4.45,27.91,0C290,340.36,292,337.68,292.18,335Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M272.26,319.1c.88,2-.82,4.71-3.79,6s-6.11.74-7-1.27.81-4.7,3.79-6S271.37,317.09,272.26,319.1Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260.83,327.29a2.59,2.59,0,1,1-3.16-.88A2.35,2.35,0,0,1,260.83,327.29Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M223.79,276.61a28.39,28.39,0,0,1-10,21.7A18.57,18.57,0,0,0,207,312.43v49.42c0,1.73-1.13,3.47-3.42,4.79a14.78,14.78,0,0,1-4.3,1.57,20.17,20.17,0,0,1-8,0,15,15,0,0,1-4.29-1.57c-2.28-1.32-3.43-3.06-3.43-4.79V312.3a18.37,18.37,0,0,0-6.7-14,28.33,28.33,0,0,1-10.1-22,28.51,28.51,0,0,1,57,.23Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223.79,276.61a28.39,28.39,0,0,1-10,21.7A18.57,18.57,0,0,0,207,312.43v49.42c0,1.73-1.13,3.47-3.42,4.79a14.78,14.78,0,0,1-4.3,1.57,20.17,20.17,0,0,1-8,0,15,15,0,0,1-4.29-1.57c-2.28-1.32-3.43-3.06-3.43-4.79V312.3a18.37,18.37,0,0,0-6.7-14,28.33,28.33,0,0,1-10.1-22,28.51,28.51,0,0,1,57,.23Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M211.19,276.61a15.87,15.87,0,0,1-6.71,12.95,12.92,12.92,0,0,0-5.21,10.57v61.72a4,4,0,0,1-4,4.08h-.08a4,4,0,0,1-3.94-4.08V299.93a12.7,12.7,0,0,0-5.22-10.38,15.87,15.87,0,0,1-6.7-13.39,15.91,15.91,0,0,1,31.81.45Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.19,276.61a15.87,15.87,0,0,1-6.71,12.95,12.92,12.92,0,0,0-5.21,10.57v61.72a4,4,0,0,1-4,4.08h-.08a4,4,0,0,1-3.94-4.08V299.93a12.7,12.7,0,0,0-5.22-10.38,15.87,15.87,0,0,1-6.7-13.39,15.91,15.91,0,0,1,31.81.45Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.75,287.14a7.43,7.43,0,1,1,7.43,7.43A7.43,7.43,0,0,1,199.75,287.14Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.64,272.35a4.54,4.54,0,1,1,4.54,4.54A4.54,4.54,0,0,1,202.64,272.35Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194,265.1a2.25,2.25,0,1,1,2.25,2.25A2.25,2.25,0,0,1,194,265.1Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176,267.81a6.11,6.11,0,1,1,6.11,6.1A6.12,6.12,0,0,1,176,267.81Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175,278.84a2.87,2.87,0,1,0,2.87-2.86A2.87,2.87,0,0,0,175,278.84Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.11,288.86a4.65,4.65,0,1,1,4.65,4.65A4.65,4.65,0,0,1,177.11,288.86Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.2,295.88a3.83,3.83,0,1,1,3.83,3.83A3.83,3.83,0,0,1,188.2,295.88Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.54,272.35a2,2,0,1,1,2,1.95A1.95,1.95,0,0,1,169.54,272.35Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212,264.28a2.57,2.57,0,1,1,2.57,2.57A2.58,2.58,0,0,1,212,264.28Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 217.15,
    cy: 276.89,
    r: 2.59,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.75,279a2.59,2.59,0,1,1,2.59,2.59A2.59,2.59,0,0,1,187.75,279Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M312.75,333.9a12,12,0,0,0-24,0c0,.11,0,.22,0,.33s0,.22,0,.34c.14,1.66,1.31,3.3,3.52,4.57,4.69,2.72,12.31,2.72,17,0,2.2-1.27,3.37-2.91,3.51-4.57,0-.12,0-.22,0-.34S312.76,334,312.75,333.9Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.75,333.9a12,12,0,0,0-24,0c0,.11,0,.22,0,.33s0,.22,0,.34c.14,1.66,1.31,3.3,3.52,4.57,4.69,2.72,12.31,2.72,17,0,2.2-1.27,3.37-2.91,3.51-4.57,0-.12,0-.22,0-.34S312.76,334,312.75,333.9Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M306,323.4h0a12,12,0,0,0-17.24,10.5c0,.11,0,.22,0,.33s0,.22,0,.34c.14,1.66,1.31,3.3,3.52,4.57a15.88,15.88,0,0,0,6,1.89c-3.12-.54-5.14-4-4.18-7.87C295.19,328.7,299.7,322.25,306,323.4Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M312.75,334.57c0-.12,0-.22,0-.34s0-.22,0-.33a12,12,0,0,0-4.08-8.69c1.3,1.34,4.21,6.41,1.05,10.26-2.07,2.54-11.93,6.16-20,1.51a8.21,8.21,0,0,0,2.55,2.16c4.69,2.72,12.31,2.72,17,0C311.44,337.87,312.61,336.23,312.75,334.57Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300.61,324.91c.54,1.23-.5,2.87-2.31,3.67s-3.72.44-4.26-.78.49-2.87,2.31-3.66S300.07,323.69,300.61,324.91Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.64,329.9a1.58,1.58,0,1,1-1.92-.53A1.42,1.42,0,0,1,293.64,329.9Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M301.2,350.25a16.56,16.56,0,0,0-33.11,0c0,.16,0,.3,0,.46s0,.3,0,.46c.19,2.29,1.8,4.54,4.85,6.3,6.46,3.73,16.95,3.73,23.43,0,3-1.76,4.64-4,4.83-6.3,0-.16,0-.3,0-.46S301.21,350.41,301.2,350.25Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M301.2,350.25a16.56,16.56,0,0,0-33.11,0c0,.16,0,.3,0,.46s0,.3,0,.46c.19,2.29,1.8,4.54,4.85,6.3,6.46,3.73,16.95,3.73,23.43,0,3-1.76,4.64-4,4.83-6.3,0-.16,0-.3,0-.46S301.21,350.41,301.2,350.25Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291.83,335.8h0a16.53,16.53,0,0,0-23.74,14.45c0,.16,0,.3,0,.46s0,.3,0,.46c.19,2.29,1.8,4.54,4.85,6.3a21.8,21.8,0,0,0,8.3,2.59c-4.29-.74-7.07-5.53-5.75-10.83C277,343.09,283.23,334.21,291.83,335.8Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M301.2,351.17c0-.16,0-.3,0-.46s0-.3,0-.46a16.51,16.51,0,0,0-5.62-12c1.79,1.85,5.8,8.82,1.45,14.14-2.86,3.49-16.44,8.48-27.61,2.07a11.56,11.56,0,0,0,3.52,3c6.46,3.73,16.95,3.73,23.43,0C299.39,355.71,301,353.46,301.2,351.17Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M284.48,337.88c.74,1.68-.69,3.94-3.19,5s-5.12.62-5.86-1.07.68-4,3.18-5S283.73,336.19,284.48,337.88Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M274.88,344.74a2.18,2.18,0,1,1-2.65-.73A2,2,0,0,1,274.88,344.74Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M274.39,359a20.55,20.55,0,0,0-41.09,0,5.52,5.52,0,0,0,0,.57,5.62,5.62,0,0,0,0,.58c.23,2.84,2.24,5.63,6,7.81,8,4.64,21.05,4.64,29.08,0,3.76-2.18,5.76-5,6-7.81,0-.2,0-.38,0-.58S274.4,359.17,274.39,359Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M274.39,359a20.55,20.55,0,0,0-41.09,0,5.52,5.52,0,0,0,0,.57,5.62,5.62,0,0,0,0,.58c.23,2.84,2.24,5.63,6,7.81,8,4.64,21.05,4.64,29.08,0,3.76-2.18,5.76-5,6-7.81,0-.2,0-.38,0-.58S274.4,359.17,274.39,359Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M262.76,341h0A20.51,20.51,0,0,0,233.3,359a5.52,5.52,0,0,0,0,.57,5.62,5.62,0,0,0,0,.58c.23,2.84,2.24,5.63,6,7.81a27.13,27.13,0,0,0,10.31,3.22c-5.33-.92-8.78-6.87-7.14-13.44C244.38,350.08,252.09,339.06,262.76,341Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M274.39,360.12c0-.2,0-.38,0-.58s0-.37,0-.57a20.46,20.46,0,0,0-7-14.85c2.23,2.3,7.2,10.95,1.8,17.54-3.55,4.34-20.39,10.53-34.26,2.57a14.3,14.3,0,0,0,4.36,3.7c8,4.64,21.05,4.64,29.08,0C272.15,365.75,274.15,363,274.39,360.12Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M253.63,343.62c.92,2.09-.84,4.89-3.94,6.25s-6.36.77-7.28-1.32.85-4.9,4-6.26S252.71,341.52,253.63,343.62Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241.73,352.14a2.7,2.7,0,1,1-3.29-.91A2.44,2.44,0,0,1,241.73,352.14Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M320.41,341a7.26,7.26,0,0,0-14.52,0,2,2,0,0,0,0,.4,3.73,3.73,0,0,0,2.12,2.77,11.35,11.35,0,0,0,10.28,0,3.73,3.73,0,0,0,2.12-2.77,2,2,0,0,0,0-.4Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320.41,341a7.26,7.26,0,0,0-14.52,0,2,2,0,0,0,0,.4,3.73,3.73,0,0,0,2.12,2.77,11.35,11.35,0,0,0,10.28,0,3.73,3.73,0,0,0,2.12-2.77,2,2,0,0,0,0-.4Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M316.3,334.67h0A7.24,7.24,0,0,0,305.89,341a2,2,0,0,0,0,.4,3.73,3.73,0,0,0,2.12,2.77,9.83,9.83,0,0,0,3.65,1.14c-1.89-.33-3.11-2.43-2.53-4.76C309.81,337.87,312.53,334,316.3,334.67Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.05
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M320.41,341.41a2,2,0,0,0,0-.4,7.22,7.22,0,0,0-2.46-5.25c.79.81,2.54,3.87.63,6.2-1.25,1.53-7.21,3.72-12.11.91a5.23,5.23,0,0,0,1.54,1.31,11.35,11.35,0,0,0,10.28,0A3.73,3.73,0,0,0,320.41,341.41Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M313.08,335.58c.32.74-.3,1.73-1.4,2.21s-2.25.27-2.57-.47.3-1.73,1.39-2.21S312.75,334.84,313.08,335.58Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M308.87,338.59a1,1,0,1,1-1.16-.32A.87.87,0,0,1,308.87,338.59Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M83.32,327.29a12,12,0,0,1,24,0c0,.11,0,.22,0,.33s0,.22,0,.34c-.14,1.66-1.31,3.29-3.52,4.57-4.69,2.71-12.31,2.71-17,0-2.2-1.28-3.37-2.91-3.51-4.57,0-.12,0-.22,0-.34S83.31,327.4,83.32,327.29Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.32,327.29a12,12,0,0,1,24,0c0,.11,0,.22,0,.33s0,.22,0,.34c-.14,1.66-1.31,3.29-3.52,4.57-4.69,2.71-12.31,2.71-17,0-2.2-1.28-3.37-2.91-3.51-4.57,0-.12,0-.22,0-.34S83.31,327.4,83.32,327.29Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.12,316.79h0a12,12,0,0,1,17.24,10.5c0,.11,0,.22,0,.33s0,.22,0,.34c-.14,1.66-1.31,3.29-3.52,4.57a15.87,15.87,0,0,1-6,1.88c3.12-.53,5.14-4,4.18-7.86C100.88,322.09,96.36,315.64,90.12,316.79Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M83.32,328c0-.12,0-.22,0-.34s0-.22,0-.33a11.93,11.93,0,0,1,4.08-8.69c-1.3,1.34-4.21,6.4-1.05,10.26,2.07,2.54,11.93,6.16,20,1.51a8.21,8.21,0,0,1-2.55,2.16c-4.69,2.71-12.31,2.71-17,0C84.63,331.25,83.46,329.62,83.32,328Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.46,318.3c-.54,1.23.5,2.87,2.31,3.66s3.72.45,4.26-.77-.5-2.87-2.31-3.67S96,317.08,95.46,318.3Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.43,323.29a1.58,1.58,0,1,0,1.92-.53A1.42,1.42,0,0,0,102.43,323.29Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M107.77,330.36a17.44,17.44,0,0,1,34.87,0c0,.17,0,.32,0,.49s0,.32,0,.48c-.2,2.42-1.9,4.79-5.11,6.64-6.8,3.93-17.86,3.93-24.68,0-3.19-1.85-4.89-4.22-5.08-6.64a3.77,3.77,0,0,1,0-.48A4,4,0,0,1,107.77,330.36Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.77,330.36a17.44,17.44,0,0,1,34.87,0c0,.17,0,.32,0,.49s0,.32,0,.48c-.2,2.42-1.9,4.79-5.11,6.64-6.8,3.93-17.86,3.93-24.68,0-3.19-1.85-4.89-4.22-5.08-6.64a3.77,3.77,0,0,1,0-.48A4,4,0,0,1,107.77,330.36Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.63,315.14h0a17.43,17.43,0,0,1,25,15.22c0,.17,0,.32,0,.49s0,.32,0,.48c-.2,2.42-1.9,4.79-5.11,6.64a23,23,0,0,1-8.75,2.73c4.53-.78,7.46-5.83,6.06-11.41C133.23,322.82,126.69,313.47,117.63,315.14Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M107.77,331.33a3.77,3.77,0,0,1,0-.48,4,4,0,0,1,0-.49,17.35,17.35,0,0,1,5.92-12.6c-1.9,1.95-6.11,9.29-1.53,14.89,3,3.68,17.31,8.93,29.07,2.18a12,12,0,0,1-3.7,3.14c-6.8,3.93-17.86,3.93-24.68,0C109.66,336.12,108,333.75,107.77,331.33Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.38,317.33c-.78,1.78.72,4.16,3.35,5.31s5.4.65,6.18-1.13-.72-4.15-3.35-5.31S126.16,315.55,125.38,317.33Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.48,324.57a2.29,2.29,0,1,0,2.79-.78A2.08,2.08,0,0,0,135.48,324.57Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M97.49,341a16.56,16.56,0,0,1,33.1,0c0,.15,0,.3,0,.46s0,.3,0,.46c-.19,2.29-1.8,4.54-4.85,6.3-6.45,3.73-16.95,3.73-23.42,0-3-1.76-4.65-4-4.83-6.3a3.54,3.54,0,0,1,0-.46A3.46,3.46,0,0,1,97.49,341Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.49,341a16.56,16.56,0,0,1,33.1,0c0,.15,0,.3,0,.46s0,.3,0,.46c-.19,2.29-1.8,4.54-4.85,6.3-6.45,3.73-16.95,3.73-23.42,0-3-1.76-4.65-4-4.83-6.3a3.54,3.54,0,0,1,0-.46A3.46,3.46,0,0,1,97.49,341Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.85,326.57h0A16.54,16.54,0,0,1,130.59,341c0,.15,0,.3,0,.46s0,.3,0,.46c-.19,2.29-1.8,4.54-4.85,6.3a22.15,22.15,0,0,1-8.3,2.59c4.29-.74,7.07-5.54,5.75-10.83C121.66,333.87,115.45,325,106.85,326.57Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M97.49,342a3.54,3.54,0,0,1,0-.46,3.46,3.46,0,0,1,0-.46,16.46,16.46,0,0,1,5.62-12c-1.8,1.85-5.8,8.82-1.46,14.13,2.86,3.5,16.44,8.49,27.61,2.08a11.56,11.56,0,0,1-3.52,3c-6.45,3.73-16.95,3.73-23.42,0C99.29,346.49,97.67,344.24,97.49,342Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.21,328.65c-.75,1.69.68,4,3.18,5.05s5.12.61,5.86-1.07-.68-3.95-3.18-5.05S115,327,114.21,328.65Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.8,335.52a2.18,2.18,0,1,0,2.65-.73A2,2,0,0,0,123.8,335.52Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M121.92,356.49a20.55,20.55,0,0,1,41.08,0,5.52,5.52,0,0,1,0,.57,5.62,5.62,0,0,1,0,.58c-.23,2.84-2.24,5.63-6,7.82-8,4.63-21,4.63-29.08,0-3.76-2.19-5.76-5-6-7.82a5.62,5.62,0,0,1,0-.58A5.52,5.52,0,0,1,121.92,356.49Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.92,356.49a20.55,20.55,0,0,1,41.08,0,5.52,5.52,0,0,1,0,.57,5.62,5.62,0,0,1,0,.58c-.23,2.84-2.24,5.63-6,7.82-8,4.63-21,4.63-29.08,0-3.76-2.19-5.76-5-6-7.82a5.62,5.62,0,0,1,0-.58A5.52,5.52,0,0,1,121.92,356.49Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.54,338.56h0A20.51,20.51,0,0,1,163,356.49a5.52,5.52,0,0,1,0,.57,5.62,5.62,0,0,1,0,.58c-.23,2.84-2.24,5.63-6,7.82a27.3,27.3,0,0,1-10.31,3.21c5.33-.92,8.78-6.87,7.14-13.44C151.92,347.61,144.21,336.59,133.54,338.56Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M121.92,357.64a5.62,5.62,0,0,1,0-.58,5.52,5.52,0,0,1,0-.57,20.45,20.45,0,0,1,7-14.85c-2.23,2.3-7.2,10.95-1.8,17.54,3.55,4.34,20.4,10.53,34.26,2.58a14.46,14.46,0,0,1-4.36,3.7c-8,4.63-21,4.63-29.08,0C124.15,363.27,122.15,360.48,121.92,357.64Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.67,341.14c-.92,2.09.85,4.89,4,6.25s6.35.77,7.27-1.32-.84-4.9-3.94-6.26S143.59,339,142.67,341.14Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.57,349.66a2.7,2.7,0,1,0,3.29-.91A2.44,2.44,0,0,0,154.57,349.66Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M237,360.18a18.76,18.76,0,0,0-37.5,0,4.52,4.52,0,0,0,0,.52,4.7,4.7,0,0,0,0,.53c.21,2.59,2,5.14,5.49,7.13,7.31,4.24,19.21,4.24,26.54,0,3.43-2,5.26-4.54,5.47-7.13a4.7,4.7,0,0,0,0-.53A4.52,4.52,0,0,0,237,360.18Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237,360.18a18.76,18.76,0,0,0-37.5,0,4.52,4.52,0,0,0,0,.52,4.7,4.7,0,0,0,0,.53c.21,2.59,2,5.14,5.49,7.13,7.31,4.24,19.21,4.24,26.54,0,3.43-2,5.26-4.54,5.47-7.13a4.7,4.7,0,0,0,0-.53A4.52,4.52,0,0,0,237,360.18Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.41,343.81h0a18.72,18.72,0,0,0-26.89,16.37,4.52,4.52,0,0,0,0,.52,4.7,4.7,0,0,0,0,.53c.21,2.59,2,5.14,5.49,7.13a24.75,24.75,0,0,0,9.41,2.94c-4.87-.84-8-6.27-6.52-12.27C209.63,352.07,216.67,342,226.41,343.81Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M237,361.23a4.7,4.7,0,0,0,0-.53,4.52,4.52,0,0,0,0-.52,18.69,18.69,0,0,0-6.36-13.56c2,2.1,6.57,10,1.64,16-3.24,4-18.62,9.61-31.28,2.35a13.11,13.11,0,0,0,4,3.37c7.31,4.24,19.21,4.24,26.54,0C235,366.37,236.81,363.82,237,361.23Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 212.96,
    cy: 348.41,
    rx: 5.6,
    ry: 3.78,
    transform: "matrix(0.92, -0.4, 0.4, 0.92, -122.12, 115.03)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.21,354a2.46,2.46,0,1,1-3-.84A2.22,2.22,0,0,1,207.21,354Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M158.69,362.22a17.84,17.84,0,0,1,35.67,0,4.18,4.18,0,0,1,0,.5,4,4,0,0,1,0,.49c-.2,2.47-1.94,4.9-5.22,6.79-7,4-18.27,4-25.24,0-3.27-1.89-5-4.32-5.21-6.79,0-.17,0-.32,0-.49S158.68,362.39,158.69,362.22Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.69,362.22a17.84,17.84,0,0,1,35.67,0,4.18,4.18,0,0,1,0,.5,4,4,0,0,1,0,.49c-.2,2.47-1.94,4.9-5.22,6.79-7,4-18.27,4-25.24,0-3.27-1.89-5-4.32-5.21-6.79,0-.17,0-.32,0-.49S158.68,362.39,158.69,362.22Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.78,346.65h0a17.8,17.8,0,0,1,25.58,15.57,4.18,4.18,0,0,1,0,.5,4,4,0,0,1,0,.49c-.2,2.47-1.94,4.9-5.22,6.79a23.81,23.81,0,0,1-8.95,2.8c4.63-.8,7.62-6,6.2-11.68C184.74,354.5,178.05,344.94,168.78,346.65Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M158.69,363.21c0-.17,0-.32,0-.49s0-.33,0-.5a17.72,17.72,0,0,1,6.06-12.89c-1.94,2-6.25,9.5-1.57,15.23,3.08,3.76,17.71,9.14,29.75,2.23a12.32,12.32,0,0,1-3.79,3.21c-7,4-18.27,4-25.24,0C160.63,368.11,158.89,365.68,158.69,363.21Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.71,348.89c-.8,1.82.73,4.25,3.42,5.43s5.53.67,6.32-1.15-.73-4.25-3.42-5.44S177.51,347.07,176.71,348.89Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187,356.29a2.35,2.35,0,1,0,2.86-.79A2.12,2.12,0,0,0,187,356.29Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M205,368.46a7.26,7.26,0,0,0-14.52,0,2,2,0,0,0,0,.4,3.74,3.74,0,0,0,2.12,2.77,11.42,11.42,0,0,0,10.28,0,3.74,3.74,0,0,0,2.12-2.77,2,2,0,0,0,0-.4Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205,368.46a7.26,7.26,0,0,0-14.52,0,2,2,0,0,0,0,.4,3.74,3.74,0,0,0,2.12,2.77,11.42,11.42,0,0,0,10.28,0,3.74,3.74,0,0,0,2.12-2.77,2,2,0,0,0,0-.4Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.86,362.11h0a7.26,7.26,0,0,0-10.41,6.35,2,2,0,0,0,0,.4,3.74,3.74,0,0,0,2.12,2.77,9.83,9.83,0,0,0,3.65,1.13c-1.89-.32-3.11-2.43-2.53-4.75C194.37,365.31,197.09,361.42,200.86,362.11Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M205,368.86a2,2,0,0,0,0-.4,7.22,7.22,0,0,0-2.46-5.25c.79.81,2.54,3.87.63,6.2-1.25,1.53-7.21,3.72-12.11.91a5.23,5.23,0,0,0,1.54,1.31,11.42,11.42,0,0,0,10.28,0A3.74,3.74,0,0,0,205,368.86Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.64,363c.32.74-.3,1.73-1.4,2.21s-2.25.27-2.57-.47.3-1.73,1.39-2.21S197.31,362.29,197.64,363Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.43,366a1,1,0,1,1-1.17-.32A.87.87,0,0,1,193.43,366Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M71.83,331.28a7.27,7.27,0,0,1,14.53,0v.4a3.74,3.74,0,0,1-2.13,2.77,11.35,11.35,0,0,1-10.28,0,3.73,3.73,0,0,1-2.12-2.77,2,2,0,0,1,0-.4Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.83,331.28a7.27,7.27,0,0,1,14.53,0v.4a3.74,3.74,0,0,1-2.13,2.77,11.35,11.35,0,0,1-10.28,0,3.73,3.73,0,0,1-2.12-2.77,2,2,0,0,1,0-.4Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.94,324.94h0a7.25,7.25,0,0,1,10.42,6.34v.4a3.74,3.74,0,0,1-2.13,2.77,9.65,9.65,0,0,1-3.65,1.14c1.89-.33,3.11-2.43,2.53-4.76C82.44,328.14,79.71,324.24,75.94,324.94Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.05
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.83,331.68a2,2,0,0,1,0-.4A7.21,7.21,0,0,1,74.3,326c-.79.81-2.55,3.87-.64,6.2,1.25,1.53,7.21,3.72,12.11.91a5.1,5.1,0,0,1-1.54,1.31,11.35,11.35,0,0,1-10.28,0A3.73,3.73,0,0,1,71.83,331.68Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.17,325.85c-.33.74.3,1.73,1.39,2.21s2.25.27,2.58-.47-.3-1.73-1.4-2.21S79.49,325.11,79.17,325.85Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.38,328.86a1,1,0,1,0,1.16-.32A.86.86,0,0,0,83.38,328.86Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Flame--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.49,256.27l-18.2-4.72-18.21,4.72s-2.18,9.75.2,25,13,30.56,18,30.56,15.62-15.29,18-30.56S213.49,256.27,213.49,256.27Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.49,256.27l-18.2-4.72-18.21,4.72s-2.18,9.75.2,25,13,30.56,18,30.56,15.62-15.29,18-30.56S213.49,256.27,213.49,256.27Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M207.2,258.47H182.28c-3.56,21.52,7.87,38,12.46,38S210.76,280,207.2,258.47Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.74,258.47H199A18.87,18.87,0,0,1,201.33,270c-.52,5.81-4,13.36-6.59,13.36s-6.07-7.55-6.58-13.36a18.91,18.91,0,0,1,2.31-11.49h4.27",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--rocket--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223.18,249.69h0l-2.38-25.32h-51.1l-2.37,25.32h0c-.49,4.47,2.2,9,8.12,12.45,10.94,6.31,28.66,6.31,39.58,0C221,258.72,223.68,254.16,223.18,249.69Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.18,235.82c-10-5.77-10-15.13,0-20.91s26.22-5.77,36.22,0,10,15.14,0,20.91S187.19,241.59,177.18,235.82Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.63,243.49l-.8-8.49c-.73,3.27-3.26,6.43-7.61,8.94-10.45,6-27.4,6-37.86,0-4.35-2.51-6.89-5.67-7.62-8.93l-.8,8.47c.64,3.49,3.27,6.88,7.9,9.55,10.75,6.19,28.16,6.19,38.9,0C219.36,250.36,222,247,222.63,243.49Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.69,251.48c14.25,0,22.9-4.92,26.8-9.43l-.59-6.27c-6.66,4.6-15.72,7.1-25.81,7.1h-.8a51.78,51.78,0,0,1-19.17-3.2c.27-1.61.58-3.36.92-5.29l-2.16-10h-3l-2.38,2.24-2.16,23.08h0c-.49,4.47,2.2,9,8.12,12.45,10.94,6.31,28.66,6.31,39.58,0,.37-.21.73-.43,1.07-.65,0,0-8.28,4.12-21,3.58s-20.51-5.39-20.74-9a45.68,45.68,0,0,1,.54-8.78C179.92,249.81,186.84,251.48,195.69,251.48Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.09,242.88h-.8c-11.25.13-21.27-2.79-28.21-8.26a6.12,6.12,0,0,1,7.58-9.61c4.76,3.76,12.06,5.77,20.54,5.64h.18c8.49.09,15.78-1.88,20.54-5.64a6.12,6.12,0,1,1,7.58,9.61C216.73,240,207,242.88,196.09,242.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.79,233.28c1.84,0,8.74,5.15,24.12,5.15s25.65-6,30.56-10.7a6.2,6.2,0,0,0-.95-1.72,6.13,6.13,0,0,0-8.6-1c-4.76,3.76-12,5.73-20.54,5.64h-.18c-8.48.13-15.78-1.88-20.54-5.64a6.12,6.12,0,0,0-7.58,9.61c6.94,5.47,17,8.39,28.21,8.26a50.73,50.73,0,0,1-17.76-3.55C171.41,237,169,233.28,170.79,233.28Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.29,236c-9.33,0-18.08-2.1-24.66-5.9s-10.11-8.73-10.11-14v-.38h0c-.38-6.62-4.59-81.56-2.12-109,2.91-32.32,27.14-59.11,34.49-66.55a3.39,3.39,0,0,1,4.83,0c7.36,7.44,31.58,34.23,34.49,66.55,2.47,27.4-1.73,102.34-2.11,109h0v.38c0,5.28-3.59,10.25-10.1,14S204.61,236,195.29,236Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.29,39.54a3,3,0,0,1,2.14.9c7.33,7.42,31.48,34.12,34.38,66.31,2.43,26.95-1.61,99.95-2.09,108.54h-.05v.77c0,5.13-3.52,10-9.91,13.68s-15.22,5.84-24.47,5.84-17.95-2.07-24.47-5.84-9.91-8.55-9.91-13.68v-.77h0c-.49-8.59-4.52-81.59-2.1-108.54,2.9-32.19,27.05-58.89,34.38-66.31a3,3,0,0,1,2.15-.9m0-.76a3.75,3.75,0,0,0-2.69,1.12c-8.07,8.16-31.7,34.59-34.6,66.78-2.21,24.55,1,89.09,2.14,109.38h0c0,5.19,3.43,10.38,10.3,14.35s15.85,5.94,24.85,5.94,18-2,24.85-5.94,10.29-9.16,10.29-14.35h0c1.17-20.29,4.34-84.83,2.13-109.38C229.67,74.49,206,48.06,198,39.9a3.75,3.75,0,0,0-2.68-1.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.16,184a23.17,23.17,0,0,1-6.79,7,48.4,48.4,0,0,1-4.24,2.48c-1.5.67-3,1.41-4.53,1.93a58.45,58.45,0,0,1-38.61,0c-1.56-.51-3-1.26-4.53-1.92-1.43-.81-2.9-1.53-4.25-2.48a23.14,23.14,0,0,1-6.78-7,24.25,24.25,0,0,0,7.19,6.35c1.36.86,2.83,1.51,4.26,2.23s3,1.25,4.49,1.69a64,64,0,0,0,37.85,0c1.54-.44,3-1.1,4.49-1.69s2.9-1.38,4.26-2.24A24.25,24.25,0,0,0,230.16,184Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.16,146.14a23.14,23.14,0,0,1-6.79,7,46,46,0,0,1-4.24,2.48,47.37,47.37,0,0,1-4.53,1.93,58.37,58.37,0,0,1-38.61,0c-1.56-.52-3-1.26-4.53-1.93a47.54,47.54,0,0,1-4.25-2.48,23,23,0,0,1-6.78-7,24.53,24.53,0,0,0,7.19,6.35c1.36.85,2.83,1.51,4.26,2.23s3,1.25,4.49,1.69a64,64,0,0,0,37.85,0c1.54-.44,3-1.11,4.49-1.7s2.9-1.37,4.26-2.23A24.39,24.39,0,0,0,230.16,146.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.56,166.43a1.28,1.28,0,1,1-1.28-1.28A1.28,1.28,0,0,1,196.56,166.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 217.03,
    cy: 161.05,
    r: 1.28,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.53,
    cy: 161.05,
    r: 1.28,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.3,200.51a1.28,1.28,0,1,1-1.28-1.28A1.27,1.27,0,0,1,218.3,200.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.81,200.51a1.28,1.28,0,1,1-1.28-1.28A1.27,1.27,0,0,1,174.81,200.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.27,92.91c-11.59,6.69-30.37,6.69-42,0-7.23-4.19-10-10-8.14-15.38h0c.39-.86.79-1.7,1.2-2.53a141.17,141.17,0,0,1,25.24-35.1,3.76,3.76,0,0,1,5.35,0,140.8,140.8,0,0,1,25.2,35c.44.88.86,1.75,1.27,2.64C226.21,83,223.48,88.74,216.27,92.91Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.29,94.1c-7.26,0-14-1.6-19.07-4.51-5.28-3-7.64-6.94-6.48-10.69.35-.75.7-1.48,1.06-2.21a138,138,0,0,1,24.49-34.07s-7.2,14.66-8.84,27S189.08,89.93,195.29,94.1Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.39,45.44A80.1,80.1,0,0,1,205,52.77c2.06,2.56,4,5.22,5.82,7.94.92,1.36,1.79,2.76,2.66,4.14s1.7,2.82,2.46,4.27A79.43,79.43,0,0,1,220.13,78l-5.26-8.28c-1.76-2.74-3.53-5.47-5.36-8.17s-3.65-5.39-5.5-8.08Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.48,40.88l-2.2-21.52-2.2,21.52h0a1.1,1.1,0,0,0,.65.9,3.45,3.45,0,0,0,3.1,0,1.1,1.1,0,0,0,.65-.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 195.29,
    cy: 125.14,
    r: 19.52,
    transform: "translate(-33.02 84.26) rotate(-22.5)",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 195.29,
    cy: 125.14,
    r: 19.52,
    transform: "translate(-33.02 84.26) rotate(-22.5)",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 195.29,
    cy: 127.41,
    r: 19.52,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.32,145.62,196,128.27l16,9.23c.13-.22.26-.44.38-.66l-16-9.24,18.19-3.2c0-.26-.09-.51-.14-.76l-18.19,3.21,11.87-14.14c-.19-.17-.38-.34-.58-.5l-11.87,14.15V107.9h-.77v18.46L183,112.21l-.58.5,11.87,14.14-18.19-3.21c0,.25-.09.5-.13.76l18.19,3.2-16,9.24c.12.22.25.44.38.66l16-9.23-6.32,17.35.72.26,6.32-17.35,6.31,17.35C201.85,145.8,202.08,145.71,202.32,145.62Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 195.29,
    cy: 127.41,
    r: 14.1,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.29,113.31a14.1,14.1,0,0,0-14,12.76,14.1,14.1,0,0,0,28.08.08A14.1,14.1,0,0,0,195.29,113.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.55,123.82a4.21,4.21,0,1,1-4.21-4.21A4.21,4.21,0,0,1,206.55,123.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.92,132.16a2.43,2.43,0,1,1-2.43-2.43A2.42,2.42,0,0,1,203.92,132.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.55,189.41a8.28,8.28,0,0,0-8.27-8.63h0a8.28,8.28,0,0,0-8.27,8.63s0,3.05,0,3.58l1.85,43.94a5,5,0,0,0,5,4.83h2.78a5,5,0,0,0,5-4.83L203.55,193C203.58,192.46,203.55,189.41,203.55,189.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.67,241.76h-2.78a5,5,0,0,1-5-4.83L187,193a8.28,8.28,0,0,1,8.27-8.63h0a8.28,8.28,0,0,1,8.27,8.63l-1.85,43.94A5,5,0,0,1,196.67,241.76Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.28,271.56h0a2.48,2.48,0,0,1-2.48-2.4l-2.15-72.82a4.63,4.63,0,0,1,4.63-4.8h0a4.63,4.63,0,0,1,4.63,4.8l-2.15,72.82A2.48,2.48,0,0,1,195.28,271.56Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.8,269.16a2.48,2.48,0,0,0,5,0L198,260l-.11-.29s-.35,4.27-2.64,3.21c-1.64-.76-2.65-5.85-3-10.91Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.91,196.34a4.63,4.63,0,0,0-4.63-4.8h0a5,5,0,0,0-.78.07c2.83.54,3.73,2.26,3.89,9.13.16,7.19-.55,65.44-.55,65.44Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.85,164.17c-1.12-.64-2.67-.53-4.4.47A13.93,13.93,0,0,0,223.19,176l1.49,48.47a2.37,2.37,0,0,0,1,2.14c.55.31,2.55,1.49,3.12,1.8a2.37,2.37,0,0,0,2.36-.24l2.7-1.55a7.63,7.63,0,0,0,3.41-5.74l1.51-50.57c.06-2.16-.65-3.68-1.84-4.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.21,228.19c-1.83,1.06-3.36.2-3.42-1.91l-1.5-48.47a13.94,13.94,0,0,1,6.27-11.38c3.58-2.07,6.38-.32,6.27,3.9l-1.51,50.57a7.63,7.63,0,0,1-3.41,5.74Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.85,164.17c.54.3,2.61,1.5,3.13,1.8-1.13-.65-2.68-.54-4.43.46a13.75,13.75,0,0,0-5.64,7.5l-3.11-1.8a13.8,13.8,0,0,1,5.65-7.5C231.19,163.64,232.73,163.53,233.85,164.17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.48,177l-2.82-1.62-3.1,1.79V256.3c3.26,1.89,6.3,2,8.75.56l3.08-1.79c3.08-1.76,5.23-5.89,5.74-11.84L253,210.65C254.05,197.87,247.26,182.09,238.48,177Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.48,177l-2.82-1.62-3.1,1.79V256.3c3.26,1.89,6.3,2,8.75.56l3.08-1.79c3.08-1.76,5.23-5.89,5.74-11.84L253,210.65C254.05,197.87,247.26,182.09,238.48,177Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M232.56,256.3h0V177.19l2.81,1.63c8.78,5.07,15.57,20.85,14.47,33.62L247,245C246.1,255.71,239.9,260.54,232.56,256.3Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.56,256.3h0V177.19l2.81,1.63c8.78,5.07,15.57,20.85,14.47,33.62L247,245C246.1,255.71,239.9,260.54,232.56,256.3Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.1,244.12c-.45,5.21-5.62,7.22-9.38,3.23s-5.16-9.16-5.16-25.24V256.3c7.34,4.24,13.54-.59,14.46-11.27Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.72,164.17c1.12-.64,2.67-.53,4.4.47A13.94,13.94,0,0,1,167.39,176l-1.5,48.47a2.37,2.37,0,0,1-1,2.14c-.55.31-2.55,1.49-3.11,1.8a2.39,2.39,0,0,1-2.37-.24l-2.69-1.55a7.62,7.62,0,0,1-3.42-5.74l-1.51-50.57c-.05-2.16.66-3.68,1.85-4.36C154.11,165.67,156.18,164.47,156.72,164.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.36,228.19c1.83,1.06,3.36.2,3.42-1.91l1.5-48.47A14,14,0,0,0,158,166.43c-3.58-2.07-6.39-.32-6.28,3.9l1.51,50.57a7.62,7.62,0,0,0,3.42,5.74Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.72,164.17c-.54.3-2.61,1.5-3.13,1.8,1.13-.65,2.69-.54,4.43.46a13.7,13.7,0,0,1,5.64,7.5l3.12-1.8a13.82,13.82,0,0,0-5.66-7.5C159.39,163.64,157.84,163.53,156.72,164.17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.09,177l2.82-1.62,3.11,1.79V256.3c-3.27,1.89-6.31,2-8.76.56l-3.08-1.79c-3.07-1.76-5.22-5.89-5.74-11.84l-2.81-32.58C136.52,197.87,143.31,182.09,152.09,177Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.09,177l2.82-1.62,3.11,1.79V256.3c-3.27,1.89-6.31,2-8.76.56l-3.08-1.79c-3.07-1.76-5.22-5.89-5.74-11.84l-2.81-32.58C136.52,197.87,143.31,182.09,152.09,177Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M158,256.3h0V177.19l-2.82,1.63c-8.78,5.07-15.57,20.85-14.47,33.62L143.55,245C144.47,255.71,150.67,260.54,158,256.3Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158,256.3h0V177.19l-2.82,1.63c-8.78,5.07-15.57,20.85-14.47,33.62L143.55,245C144.47,255.71,150.67,260.54,158,256.3Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.47,244.12c.45,5.21,5.63,7.22,9.38,3.23s5.16-9.16,5.17-25.24V256.3c-7.35,4.24-13.55-.59-14.47-11.27Z",
    style: {
      opacity: 0.2
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaunchingAmico);
export default __webpack_public_path__ + "static/media/Launching-amico.5775890a45b6512be0b1e03b0eaf5a67.svg";
export { ForwardRef as ReactComponent };